import { render, staticRenderFns } from "./PatientStoryTable.vue?vue&type=template&id=415119dc"
import script from "./PatientStoryTable.vue?vue&type=script&lang=js"
export * from "./PatientStoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports